/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSetupDoc.css";
import { API_ENDPOINT, PLATFORM } from "../../../config";
import { simpleFetch } from "../../../restWrapper";
import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import PropTypes from "prop-types";

class OrgSetupDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      loading: true,
      errMsg: "",
    };
  }

  componentDidMount() {
    this.fetchDoc().then((res) => {
      this.setState({
        loading: false,
      });
    });
  }

  fetchDoc() {
    const languageObj = this.props.languageObj;
    return simpleFetch("/organizations/files", "GET", {}).then((res) => {
      this.setState({
        files: languageObj.files,
      });
      if (res.status === 200) {
        if (res.body.length >= 1) {
          this.setState({
            errMsg: "",
            files: res.body,
          });
        }
      }
      return res;
    });
  }

  render() {
    const languageObj = this.props.languageObj;
    if (this.state.loading || !languageObj) {
      return <this.props.RenderFullPageLoading />;
    }
    const errObj = languageObj.errMsg;
    const plugErrMsg = languageObj.plugErrMsg;

    const handleFile = (e) => {
      if (this.state.loading) return false;
      let data = new FormData();
      const file = e.target.files[0];
      if (file.type !== "application/pdf") {
        this.setState({
          errMsg: errObj[0],
        });
        return false;
      }
      this.setState({
        loading: true,
      });
      data.append("file", file);
      if (data) {
        fetch(API_ENDPOINT + "/organizations/files", {
          // Your POST endpoint
          credentials: "include",
          method: "POST",
          body: data, // This is your file object
        })
          .then((res) => {
            if (!res.ok) {
              // Handle upload failure
              return res.json().then((body) => {
                const errorMsg =
                  body?.message ||
                  (PLATFORM === "plug"
                    ? plugErrMsg.uploadFailed
                    : errObj[2]);
                this.setState({
                  errMsg: errorMsg,
                  loading: false,
                });
                throw new Error(errorMsg);
              });
            }
            return this.fetchDoc();
          })
          .then(() => {
            this.setState({
              loading: false,
              errMsg: "",
            });
          })
          .catch((err) => {
            // Handle network errors
            if (!this.state.errMsg) {
              this.setState({
                errMsg:
                  PLATFORM === "plug"
                    ? plugErrMsg.networkError
                    : errObj[2],
                loading: false,
              });
            }
          });
      }
    };

    const nextBtn = () => {
      const docErrorMsg =
        PLATFORM === "plug"
          ? plugErrMsg.missingBR
          : errObj[1];
      try {
        if (
          this.state.files !== languageObj.files &&
          this.state.files.length > 0
        ) {
          this.props.nextBtn();
        } else {
          this.setState({
            errMsg: docErrorMsg,
          });
        }
      } catch (e) {
        this.setState({
          errMsg: docErrorMsg,
        });
      }
    };

    const RenderFiles = () => {
      if (
        !this.state.files ||
        this.state.files.length < 1 ||
        this.state.files === languageObj.files
      )
        return false;
      const RenderItem = (props) => {
        if (!props.file) return false;
        const file = props.file;
        const key = "file" + file._id;

        const downloadDoc = (e) => {
          if (this.state.loading) return false;
          this.setState({
            loading: true,
          });
          const link = !props.file._id
            ? ""
            : API_ENDPOINT + "/organizations/files/" + props.file._id;
          window.open(link, "_blank");
          this.setState({
            loading: false,
          });
        };

        const deleteDoc = (e) => {
          if (this.state.loading) return false;
          this.setState({
            loading: true,
            errMsg: "",
          });
          simpleFetch("/organizations/files/" + file._id, "DELETE", {})
            .then((res) => {
              if (res.status !== 204) {
                const errorMsg =
                  res.body?.message ||
                  (PLATFORM === "plug"
                    ? plugErrMsg.deleteFailed
                    : errObj[2]);
                this.setState({
                  errMsg: errorMsg,
                });
              }
              return this.fetchDoc();
            })
            .then(() => {
              this.setState({
                loading: false,
              });
            })
            .catch((err) => {
              this.setState({
                errMsg:
                  PLATFORM === "plug"
                    ? plugErrMsg.deleteFailed
                    : errObj[2],
                loading: false,
              });
            });
        };

        return (
          <div className="OrgSetupDoc-item" key={key}>
            <div className="OrgSetupDoc-docName" onClick={downloadDoc}>
              {" "}
              {file.filename}
            </div>
            <div className="OrgSetupDoc-deleteContainer" onClick={deleteDoc}>
              <div className="OrgSetupDoc-deleteBtn" />
            </div>
          </div>
        );
      };

      return (
        <div className="OrgSetupDoc-itemContainer">
          {this.state.files.map((file) => (
            <RenderItem key={file._id + "234"} file={file} />
          ))}
        </div>
      );
    };
    return (
      <div className="OrgSetupDoc-view">
        <div className="OrgSetupDoc-center">
          <div className="OrgSetupDoc-header">
            {/* Conditionally render logo based on platform */}
            <div
              className={
                PLATFORM === "plug"
                  ? "OrgSetupDoc-PlugLogo"
                  : "OrgSetupDoc-CheckPlusLogo"
              }
            />

            <div className="OrgSetupDoc-headerBottom">
              <div className="OrgSetupDoc-backBtn" onClick={this.props.backBtn}>
                <div className="OrgSetupDoc-backIcn" />
              </div>

              <div className="OrgSetupDoc-steps">{languageObj.step}</div>
            </div>
          </div>

          <div className="OrgSetupDoc-prompt">
            <div className="OrgSetupDoc-description">
              {PLATFORM === "plug" ? (
                <>{languageObj.plugDescription}</>
              ) : (
                <>
                  {languageObj.description[0]}
                  {languageObj.description[1]}
                  <p />
                  {languageObj.description[2]}
                </>
              )}
            </div>

            <div className="OrgSetupDoc-addBtn">
              <div className="OrgSetupDoc-addIcn" />
              <input type="file" onChange={handleFile} />
            </div>

            <RenderFiles />

            <div
              className="OrgSetupDoc-logoutTxt"
              onClick={this.props.orgLogout}
            >
              {languageObj.rightBtn}
            </div>

            <div className="OrgSetupDoc-nextBtn" onClick={nextBtn}>
              <div className="OrgSetupDoc-nextIcnContainer">
                <div className="OrgSetupDoc-nextIcn" />
              </div>

              <div className="OrgSetupDoc-nextText">
                {languageObj.submitBtn}
              </div>
            </div>

            {renderErrorMsg(this.state.errMsg)}
          </div>
        </div>
      </div>
    );
  }
}
OrgSetupDoc.propTypes = {
  languageObj: PropTypes.object,
  RenderFullPageLoading: PropTypes.func,
  backBtn: PropTypes.func,
  nextBtn: PropTypes.func,
  orgLogout: PropTypes.func,
};
export default OrgSetupDoc;
